<template>
<div class="cal">
<div class="row">
	<h4>{{year}}年{{month}}月</h4>
</div>
<div class="row">
    <div class="col" v-for="v in week" :key="v.id">{{v}}</div>
	<div class="col" v-for="v in oneEmpty" :key="v.id">&nbsp;</div>
	<div :class="{col:true,green:v.total>0}" v-for="v in total" :key="v.date" @click="select(v)">{{v.date}}</div>
	<div class="col" v-for="v in lastEmpty" :key="v.id">&nbsp;</div>
</div>
</div>
</template>


<style scoped>
.cal{border:1px solid #ddd;}
.col{width:14.2857%;text-align: center;border-right:1px solid #eee;border-top:1px solid #eee;}
h4{text-align: center;}
.green{background: #449d44;color:white;}
</style>


<script>

export default {
	props:{
		time:"",
	},
	watch:{
		"time":"init",
	},
	data:function(){
      return {
         oneEmpty:0,
         lastEmpty:0,
         total:[],
         week:["一","二","三","四","五",'六','日'],
         year:0,
         month:0,
      }
	},
	methods:{
       init:function(){
	       var time=this.time[0]['time'];
	       var d=new Date(time);
	       var y=this.year=d.getFullYear();
		   var m=this.month=d.getMonth()+1;
		   m=m<10?"0"+m:m;
		   var fd=new Date(y+"-"+m+"-01").getDay();//一号的星期数0-6
		   var ld=new Date(y,m,0).getDate();//一个月的天数
	       for(var i=0;i<ld;i++){
	       	 this.total[i]={
	       	 	date:i+1,
	       	 	total:this.gettotal(i+1),
	       	 };
	       }
		   var len=this.oneEmpty=fd?fd-1:6;//第一行空缺的天数
		   this.lastEmpty=(len+ld)%7?7-(len+ld)%7:0;
       },
       gettotal:function(index){
         var len=this.time.length;
         for(var i=0;i<len;i++){
           var date=new Date(this.time[i]['time']).getDate();
            if(index==date){
            	var total=this.time[i]['total'];
            	return total?total:0;
            }
         }
         return 0;
       },
       select:function(v){
       	if(v.total==0){this.$toast("预约名额已满，请换一天");return;}
       	var date=this.year+"-"+fun.two(this.month)+"-"+fun.two(v.date);
       	this.$emit("select",date);
       }
	}
}	
</script>


// WEBPACK FOOTER //
// src/lib/calendar.vue